// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__1ZpLM","greenTitle":"styles_greenTitle__30zcV"};